import { InquisitiveActivitiesComponentType } from 'global/graphql/scalars.type';
import type { SuggestedAnswerFragment } from '../suggested-answers.graphql.generated';
import {
  ACTIVITIES_ANSWER_MODE_FREE,
  ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE,
  ACTIVITIES_COMPONENT_TYPE_DRAW,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE,
  ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE,
  SUGGESTED_ANSWER_VARY,
} from 'global/constants';
import { getImageAnswer } from '../../shared/logic/get-image-answer';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';
import { isRichtextValueEmpty } from '../../shared/logic/get-richtext-value';
import {
  ComponentInteractiveResponseCategorise,
  ComponentInteractiveResponseSequence,
  ComponentMultipleChoice,
} from '../../component.constants';

export function hasNoRichTextData(
  suggestedAnswer: SuggestedAnswerFragment | null
) {
  return (
    suggestedAnswer?.suggestedAnswerType !== SUGGESTED_ANSWER_VARY &&
    suggestedAnswer?.suggestedAnswers?.every(suggestedData =>
      isRichtextValueEmpty(getRichtextAnswer(suggestedData))
    )
  );
}

export function hasAnswerData(
  components: {
    type: InquisitiveActivitiesComponentType;
    suggestedAnswerProperties: SuggestedAnswerFragment | null;
  }[]
) {
  return components.some(component => {
    // any component that has answers may vary
    if (
      component.suggestedAnswerProperties?.suggestedAnswerType ===
      SUGGESTED_ANSWER_VARY
    ) {
      return true;
    }

    if (
      component.type === ACTIVITIES_COMPONENT_SUB_ACTIVITY_TYPE_MULTIPLE_CHOICE
    ) {
      const multipleChoiceComp = component as ComponentMultipleChoice;
      if (
        multipleChoiceComp.properties.multipleChoice.answerMode !==
        ACTIVITIES_ANSWER_MODE_FREE
      ) {
        return true;
      }
    }

    if (
      component.type ===
        ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE_CATEGORISE &&
      (component as ComponentInteractiveResponseCategorise).properties
        .interactiveResponseCategorise.answerType !==
        ACTIVITIES_ANSWER_MODE_FREE
    ) {
      return true;
    }

    if (
      component.type === ACTIVITIES_COMPONENT_TYPE_INTERACTIVE_RESPONSE &&
      (component as ComponentInteractiveResponseSequence).properties
        .interactiveResponse.answerType !== ACTIVITIES_ANSWER_MODE_FREE
    ) {
      return true;
    }

    if (component.type === ACTIVITIES_COMPONENT_TYPE_DRAW) {
      return component.suggestedAnswerProperties?.suggestedAnswers?.some(
        suggested =>
          getImageAnswer(suggested) ||
          !isRichtextValueEmpty(getRichtextAnswer(suggested))
      );
    }

    return component.suggestedAnswerProperties?.suggestedAnswers?.some(
      suggested => {
        return !isRichtextValueEmpty(getRichtextAnswer(suggested));
      }
    );
  });
}
